<template>
  <div class="businessInfo">
  <PageContent class="batch-edit-wrapper">
    <span class="summary-title">
      Please review and confirm your submission
    </span>
    <PanelV2 type="w6" title="Business Information" @nextClick="commitData()" mode="edit">
      <template v-slot:title-solt>
        <!-- <span class="btn-action">EDIT</span> -->
      </template>
      <template v-slot:content-solt>
        <div class="underline">
          <BusinessDetail ref="detailForm" v-model="detailData" />
        </div>
        <div class="underline">
          <div class="radioBox">
            <p class="radioTitle">Same as Home Address</p>
            <BdoRadios
              :value="sameAasHomeAddress"
              @onClick="updateRadioValue"
            />
          </div>
          <BusinessAddr ref="addrForm" v-model="addressData" :class="isShowArrow" :selectOptions="selectOptions" :disabled="disabled"  />
        </div>

        <OnlineStore ref="OnlineStoreData" />
      </template>
    </PanelV2>
  </PageContent>
  </div>
</template>

<script>
import BusinessDetail from "../forms/IndividualF.val";
import BusinessAddr from "../forms/IndividualG.val";
import OnlineStore from "../components/OnlineStore.vue";
import API from "@/api";
import {provinceData, cityData} from "../../common-data/config";
import barangayData from "../../common-data/barangay-data";

export default {
  name: "EditBusinessInfo",
  components: {
    BusinessDetail,
    BusinessAddr,
    OnlineStore,
  },
  data() {
    return {
      addressData: "",
      detailData: "",
      businessAddrData: "",
      sameAasHomeAddress: "2",
      homeAddress: {},
      storeData: {
        formArr: [
          { socialMedia: "", url: "" },
          { socialMedia: "", url: "" },
        ],
      },
      disabled: false,
      status1: true,
      status2: true,
      status4: true,
      selectOptions: {
        province: provinceData,
        city: [],
        barangay: []
      },
    };
  },
  created() {
    API.getBdoProcessData({
      pageNo: "999",
      token: this.getCookieItem("token"),
    }).then((res) => {
      if (res.success) {
        Object.assign(this.addressData, res.obj.businessAddress);
        this.$refs.addrForm.updateDataForm(this.addressData);
        Object.assign(this.homeAddress, res.obj.homeAddress);
        this.businessAddrData = res.obj.businessAddress;
        this.sameAasHomeAddress = res.obj.businessAddress.sameAasHomeAddress
        this.status4 = res.obj.businessAddress.sameAasHomeAddress == '1'
        Object.assign(this.detailData, res.obj.businessDetails);
        this.detailData['businessName_1'] = this.detailData.businessName
        this.$refs.detailForm.updateDataForm(this.detailData);
        this.$refs.OnlineStoreData.doProcess(res.obj.businessOnlineStore);
      }
    });
  },
  mounted() {
    this.status4 = this.sameAasHomeAddress == '1'
  },
  computed:{
    isShowArrow() {
      if(this.sameAasHomeAddress == 1) {
        return 'isShowArrow'
      } else {
        return ''
      }
    }
  },
  watch: {
    'addressData.province': function(val) {
      if (!this.status1) {
        this.$set(this.addressData, 'city', '')
      } else {
        this.status1 = false
      }
      this.selectOptions.city = val ? cityData[val] : []
    },
    'addressData.city':function(val) {
      if (!this.status2) {
        this.$set(this.addressData, 'barangay', '')
      } else {
        this.status2 = false
      }
      this.selectOptions.barangay = barangayData[val || ''] || []
    },
    'addressData.barangay':function(val) {
      if (this.selectOptions.barangay.length > 0 && val) {
        const data = this.selectOptions.barangay.filter(value => value.value === val)[0].zipCode
        this.$set(this.addressData, 'zipCode', data[0])
      } else {
        this.$set(this.addressData, 'zipCode', '')
      }
    },
    sameAasHomeAddress:function(val) {
      if(val == '1') {
        this.disabled = true
      } else {
        this.disabled = false
      }
      this.$nextTick(() => {
        this.$refs.addrForm.$refs.appForm.clearValidate()
      })
    }
  },
  methods: {
    updateRadioValue(val) {
      this.sameAasHomeAddress = val;
      this.status1 = true
      this.status2 = true
      this.status3 = true
      if (val == "1") {
        this.$refs.addrForm.updateDataForm(this.homeAddress);
      } else {
        this.$refs.addrForm.updateDataForm({});
        // this.$refs.addrForm.updateDataForm(this.businessAddrData);
      }
    },
    commitData() {
      const { sameAasHomeAddress } = this;
      let onlineStoreList = [];
      this.$refs.OnlineStoreData.formData.onlineStoreList.filter((item) => {
        onlineStoreList.push(item);
      });
      Promise.all(
        [
          this.$refs.detailForm.$refs.appForm,
          this.$refs.addrForm.$refs.appForm,
          this.$refs.OnlineStoreData.$refs.formData,
        ].map((form) => {
          return new Promise((reslove) => {
            form.validate((valid) => {
              reslove(valid);
            });
          });
        })
      ).then((res) => {
        const [res1, res2, res3] = res;
        if (res1 && res2 && res3) {
          API.editBdoProcess({
            token: this.getCookieItem("token"),
            pageNo: `5,6,9`,
            businessAddress: { ...this.addressData, sameAasHomeAddress },
            businessDetails: {...this.detailData, businessName: this.detailData['businessName_1']},
            businessOnlineStore: { onlineStoreList },
          }).then((res) => {
            if (res.success) {
              window.history.go(-1);
            }
          });
        }
      });
    },
  },
};
</script>


<style lang="scss">
.businessInfo {
  .panel-v2.content-area {
    margin: 16px 0;
  }
  .radioBox {
    margin-bottom: 40px;
    .radioTitle {
      margin-bottom: 4px;
      font-size: 16px;
      color: #2e2e2e;
      // font-family: Nunito;
    }
  }
  .isShowArrow {
    span.el-input__suffix {
      display: none;
    }
  }
  .underline {
    border-bottom: 1px solid #e4e4e4;
    margin-bottom: 30px;
  }
  .el-form-item {
    &:nth-child(6) {
      width: 26% !important;
    }
    &:nth-child(7) {
      width: 18% !important;
    }
  }
}
</style>
